import { selectMode } from '../../features/appConfigSlice'
import { useAppSelector } from '../../hooks/useAppSelector'
import { ErrorObject } from '../../models/types'
import Button from '../Button/Button'
import { Loader } from '../Loader/Loader'
import {
  errorContainer,
  loaderContainerVariants,
  subtitleStyle,
  titleStyle,
} from './LoaderProvider.css'

export type LoaderProviderProps = {
  enabled: boolean
  children: JSX.Element
  error?: ErrorObject | null
  onClickReload?: (errorType?: string) => void
}

const LoaderProvider = ({
  enabled,
  children,
  error,
  onClickReload,
}: LoaderProviderProps) => {
  const mode = useAppSelector(selectMode)
  const handlerClickButton = () => {
    onClickReload && onClickReload(error?.errorType)
  }

  if (error && !enabled) {
    return (
      <div className={mode ? loaderContainerVariants[mode] : ''}>
        <div className={errorContainer}>
          <h1 className={titleStyle} data-testid="error-title">
            Something went wrong
          </h1>
          <span className={subtitleStyle} data-testid="error-message">
            {error.message}
          </span>
          {error.showButton && (
            <Button
              dataTestId="error-button"
              onClick={handlerClickButton}
              label="Try again"
            />
          )}
        </div>
      </div>
    )
  }

  return enabled && !error ? (
    <div
      className={
        mode ? loaderContainerVariants[mode] : loaderContainerVariants.modal
      }
    >
      <Loader />
    </div>
  ) : (
    children
  )
}

export default LoaderProvider
